module.exports = __webpack_public_path__ + "static/media/noun-get-started.93c15a90.svg";